import { useEffect } from "react";
import React from "react";
import { HashRouter, Link, Redirect, Route, Switch } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router';
import ScrollToTop from './components/scrollToTop.jsx'
import Registro from "./pages/Registro.jsx"
import Recupera from "./pages/Recupera.jsx"
import Menu from "./pages/Menu.jsx"
import Sesion from "./pages/Sesion.jsx"
import Inicio from "./pages/Inicio.jsx"
import Copa from "./pages/Copa.jsx"
import Usuario from "./pages/Usuario.jsx"
import Carta from "./pages/Carta.jsx"
import Acerca from "./pages/Acerca.jsx"
import Ranking from "./pages/Ranking.jsx"
import Visitados from "./pages/Visitados.jsx"
import BlockBackButton from "./components/BlockBackButton.jsx";
import Drawer from "./components/drawer.jsx";
import RutaProtegida from "./components/RutaProtegida.jsx";
import SoloMovilesWrapper from "./components/SoloMovilesWrapper.jsx";

//import { registrarToken, escucharNotificaciones } from "./firebase";
function AppContent() {
	const location = useLocation();

	const redirecciones = {
		"/Usuario": "/Inicio",
		"/Copa": "/Inicio",
		"/Carta": "/Inicio",
		"/Acerca": "/Inicio",
		"/Ranking": "/Inicio",
		"/Visitados": "/Inicio",
		"/Recupera": "/Sesion",
		"/Registro": "/Sesion",
		"/Menu": "/Sesion",
	};

	const mostrarDrawer = ["/Inicio", "/Usuario", "/Copa", "/Acerca", "/Carta", "/Ranking", "/Visitados"];

	/* useEffect(() => {
    
    registrarToken();
    escucharNotificaciones();
  }, []);*/

	return (
		<SoloMovilesWrapper>
		<>
		
			<BlockBackButton redirecciones={redirecciones} />
			{mostrarDrawer.includes(location.pathname) && <Drawer />}

			<Switch>
				<Route exact path="/">
					<Redirect to="/Sesion" />
				</Route>
				<Route path="/Sesion" component={Sesion} />
				<RutaProtegida  path="/Inicio" component={Inicio} />
				<RutaProtegida  path="/Usuario" component={Usuario} />
				<RutaProtegida  path="/Copa" component={Copa} />
				<RutaProtegida  path="/Carta" component={Carta} />
				<RutaProtegida  path="/Acerca" component={Acerca} />
				<RutaProtegida  path="/Ranking" component={Ranking} />
				<RutaProtegida  path="/Visitados" component={Visitados} />
				<Route path="/Recupera" component={Recupera} />
				<Route path="/Registro" component={Registro} />
				<Route path="/Menu" component={Menu} />
			</Switch>
			
		</>
		</SoloMovilesWrapper>
	);
}

// ------------------ Componente raíz ------------------
export default function App() {
  return (
	
    <HashRouter>
      <AppContent />
    </HashRouter>
	
  );
}